export const ListSkillsJobSeekers = () => {
  return [
    { name: "Microsoft Excel" },
    { name: "Data Analysis" },
    { name: "Python Programming" },
    { name: "Graphic Design" },
    { name: "SEO Optimization" },
    { name: "Copywriting" },
    { name: "Accounting" },
    { name: "Project Management" },
    { name: "Web Development" },
    { name: "Java Programming" },
    { name: "Social Media Management" },
    { name: "Video Editing" },
    { name: "SQL Database" },
    { name: "Digital Marketing" },
    { name: "Cloud Computing" },
    { name: "Photography" },
    { name: "Foreign Language Proficiency" },
    { name: "CAD Design" },
    { name: "Customer Support Tools" },
    { name: "Google Analytics" },
    { name: "HTML/CSS" },
    { name: "Adobe Illustrator" },
    { name: "Content Management Systems" },
    { name: "CRM Software" },
    { name: "Email Marketing Tools" },
    { name: "Linux Administration" },
    { name: "Mobile App Development" },
    { name: "Financial Reporting" },
    { name: "UX/UI Design" },
    { name: "Data Visualization" },
    { name: "Event Planning" },
    { name: "Network Troubleshooting" },
    { name: "Statistical Analysis" },
    { name: "3D Modeling" },
    { name: "Legal Drafting" },
    { name: "Supply Chain Management" },
    { name: "Welding" },
    { name: "Cybersecurity" },
    { name: "E-Commerce Management" },
    { name: "Bookkeeping" },
    { name: "Motion Graphics" },
    { name: "Market Research" },
    { name: "Technical Writing" },
    { name: "Machine Learning" },
    { name: "HTML/HRIS (Human Resources Information Systems)" },
    { name: "Voice Recording" },
    { name: "JavaScript Programming" },
    { name: "Translation" },
    { name: "Audio Editing" },
    { name: "Logistics Management" },
    { name: "Communication" },
    { name: "Teamwork" },
    { name: "Problem Solving" },
    { name: "Time Management" },
    { name: "Adaptability" },
    { name: "Creativity" },
    { name: "Leadership" },
    { name: "Emotional Intelligence" },
    { name: "Conflict Resolution" },
    { name: "Critical Thinking" },
    { name: "Public Speaking" },
    { name: "Negotiation" },
    { name: "Active Listening" },
    { name: "Stress Management" },
    { name: "Decision Making" },
    { name: "Collaboration" },
    { name: "Self-Motivation" },
    { name: "Interpersonal Skills" },
    { name: "Attention to Detail" },
    { name: "Empathy" },
    { name: "Positive Attitude" },
    { name: "Flexibility" },
    { name: "Work Ethic" },
    { name: "Coaching & Mentoring" },
    { name: "Accountability" },
    { name: "Open-mindedness" },
    { name: "Respectfulness" },
    { name: "Patience" },
    { name: "Persuasiveness" },
    { name: "Self-Confidence" },
    { name: "Delegation" },
    { name: "Analytical Thinking" },
    { name: "Networking" },
    { name: "Customer Orientation" },
    { name: "Diplomacy" },
    { name: "Resourcefulness" },
    { name: "Cultural Awareness" },
    { name: "Writing Skills" },
    { name: "Presentation Skills" },
    { name: "Influencing" },
    { name: "Problem Analysis" },
    { name: "Relationship Building" },
    { name: "Organizational Skills" },
    { name: "Honesty & Integrity" },
    { name: "Feedback Acceptance" },
    { name: "Initiative" },
    { name: "Visionary Thinking" },
    { name: "Growth Mindset" },
    { name: "Motivating Others" },
    { name: "Team Management" },
  ];
};
